// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WatchedRouteImport } from './routes/watched'
import { Route as TriageRouteImport } from './routes/triage'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as TasteRouteImport } from './routes/taste'
import { Route as ProfileRouteImport } from './routes/profile'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as MethodologyRouteImport } from './routes/methodology'
import { Route as ListsRouteImport } from './routes/lists'
import { Route as LibraryRouteImport } from './routes/library'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as CollectionsRouteImport } from './routes/collections'
import { Route as CalendarRouteImport } from './routes/calendar'
import { Route as AccountRouteImport } from './routes/account'
import { Route as AboutRouteImport } from './routes/about'
import { Route as HandleRouteImport } from './routes/$handle'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PlayIndexRouteImport } from './routes/play.index'
import { Route as NightIndexRouteImport } from './routes/night.index'
import { Route as TvIdRouteImport } from './routes/tv.$id'
import { Route as PlayTimelineRouteImport } from './routes/play.timeline'
import { Route as PlayTaglinesRouteImport } from './routes/play.taglines'
import { Route as PlaySpeedSortRouteImport } from './routes/play.speed-sort'
import { Route as PlaySequelOrFakeRouteImport } from './routes/play.sequel-or-fake'
import { Route as PlayScreeningRouteImport } from './routes/play.screening'
import { Route as PlayQuoteMatchRouteImport } from './routes/play.quote-match'
import { Route as PlayPosterRevealRouteImport } from './routes/play.poster-reveal'
import { Route as PlayLinkUpRouteImport } from './routes/play.link-up'
import { Route as PlayLeaderboardRouteImport } from './routes/play.leaderboard'
import { Route as PlayEmojiRouteImport } from './routes/play.emoji'
import { Route as PlayCastingCallRouteImport } from './routes/play.casting-call'
import { Route as PlayBalasaurdleRouteImport } from './routes/play.balasaurdle'
import { Route as PersonIdRouteImport } from './routes/person.$id'
import { Route as NightCodeRouteImport } from './routes/night.$code'
import { Route as MovieIdRouteImport } from './routes/movie.$id'
import { Route as DevRefineRouteImport } from './routes/dev.refine'
import { Route as DevArcadeRouteImport } from './routes/dev.arcade'
import { Route as BestSlugRouteImport } from './routes/best.$slug'

const WatchedRoute = WatchedRouteImport.update({
            id: '/watched',path: '/watched',getParentRoute: () => rootRouteImport
          })
const TriageRoute = TriageRouteImport.update({
            id: '/triage',path: '/triage',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const TasteRoute = TasteRouteImport.update({
            id: '/taste',path: '/taste',getParentRoute: () => rootRouteImport
          })
const ProfileRoute = ProfileRouteImport.update({
            id: '/profile',path: '/profile',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const MethodologyRoute = MethodologyRouteImport.update({
            id: '/methodology',path: '/methodology',getParentRoute: () => rootRouteImport
          })
const ListsRoute = ListsRouteImport.update({
            id: '/lists',path: '/lists',getParentRoute: () => rootRouteImport
          })
const LibraryRoute = LibraryRouteImport.update({
            id: '/library',path: '/library',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const CollectionsRoute = CollectionsRouteImport.update({
            id: '/collections',path: '/collections',getParentRoute: () => rootRouteImport
          })
const CalendarRoute = CalendarRouteImport.update({
            id: '/calendar',path: '/calendar',getParentRoute: () => rootRouteImport
          })
const AccountRoute = AccountRouteImport.update({
            id: '/account',path: '/account',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const HandleRoute = HandleRouteImport.update({
            id: '/$handle',path: '/$handle',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const PlayIndexRoute = PlayIndexRouteImport.update({
            id: '/play/',path: '/play/',getParentRoute: () => rootRouteImport
          })
const NightIndexRoute = NightIndexRouteImport.update({
            id: '/night/',path: '/night/',getParentRoute: () => rootRouteImport
          })
const TvIdRoute = TvIdRouteImport.update({
            id: '/tv/$id',path: '/tv/$id',getParentRoute: () => rootRouteImport
          })
const PlayTimelineRoute = PlayTimelineRouteImport.update({
            id: '/play/timeline',path: '/play/timeline',getParentRoute: () => rootRouteImport
          })
const PlayTaglinesRoute = PlayTaglinesRouteImport.update({
            id: '/play/taglines',path: '/play/taglines',getParentRoute: () => rootRouteImport
          })
const PlaySpeedSortRoute = PlaySpeedSortRouteImport.update({
            id: '/play/speed-sort',path: '/play/speed-sort',getParentRoute: () => rootRouteImport
          })
const PlaySequelOrFakeRoute = PlaySequelOrFakeRouteImport.update({
            id: '/play/sequel-or-fake',path: '/play/sequel-or-fake',getParentRoute: () => rootRouteImport
          })
const PlayScreeningRoute = PlayScreeningRouteImport.update({
            id: '/play/screening',path: '/play/screening',getParentRoute: () => rootRouteImport
          })
const PlayQuoteMatchRoute = PlayQuoteMatchRouteImport.update({
            id: '/play/quote-match',path: '/play/quote-match',getParentRoute: () => rootRouteImport
          })
const PlayPosterRevealRoute = PlayPosterRevealRouteImport.update({
            id: '/play/poster-reveal',path: '/play/poster-reveal',getParentRoute: () => rootRouteImport
          })
const PlayLinkUpRoute = PlayLinkUpRouteImport.update({
            id: '/play/link-up',path: '/play/link-up',getParentRoute: () => rootRouteImport
          })
const PlayLeaderboardRoute = PlayLeaderboardRouteImport.update({
            id: '/play/leaderboard',path: '/play/leaderboard',getParentRoute: () => rootRouteImport
          })
const PlayEmojiRoute = PlayEmojiRouteImport.update({
            id: '/play/emoji',path: '/play/emoji',getParentRoute: () => rootRouteImport
          })
const PlayCastingCallRoute = PlayCastingCallRouteImport.update({
            id: '/play/casting-call',path: '/play/casting-call',getParentRoute: () => rootRouteImport
          })
const PlayBalasaurdleRoute = PlayBalasaurdleRouteImport.update({
            id: '/play/balasaurdle',path: '/play/balasaurdle',getParentRoute: () => rootRouteImport
          })
const PersonIdRoute = PersonIdRouteImport.update({
            id: '/person/$id',path: '/person/$id',getParentRoute: () => rootRouteImport
          })
const NightCodeRoute = NightCodeRouteImport.update({
            id: '/night/$code',path: '/night/$code',getParentRoute: () => rootRouteImport
          })
const MovieIdRoute = MovieIdRouteImport.update({
            id: '/movie/$id',path: '/movie/$id',getParentRoute: () => rootRouteImport
          })
const DevRefineRoute = DevRefineRouteImport.update({
            id: '/dev/refine',path: '/dev/refine',getParentRoute: () => rootRouteImport
          })
const DevArcadeRoute = DevArcadeRouteImport.update({
            id: '/dev/arcade',path: '/dev/arcade',getParentRoute: () => rootRouteImport
          })
const BestSlugRoute = BestSlugRouteImport.update({
            id: '/best/$slug',path: '/best/$slug',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,HandleRoute: HandleRoute,AboutRoute: AboutRoute,AccountRoute: AccountRoute,CalendarRoute: CalendarRoute,CollectionsRoute: CollectionsRoute,ContactRoute: ContactRoute,LibraryRoute: LibraryRoute,ListsRoute: ListsRoute,MethodologyRoute: MethodologyRoute,PrivacyRoute: PrivacyRoute,ProfileRoute: ProfileRoute,TasteRoute: TasteRoute,TermsRoute: TermsRoute,TriageRoute: TriageRoute,WatchedRoute: WatchedRoute,BestSlugRoute: BestSlugRoute,DevArcadeRoute: DevArcadeRoute,DevRefineRoute: DevRefineRoute,MovieIdRoute: MovieIdRoute,NightCodeRoute: NightCodeRoute,PersonIdRoute: PersonIdRoute,PlayBalasaurdleRoute: PlayBalasaurdleRoute,PlayCastingCallRoute: PlayCastingCallRoute,PlayEmojiRoute: PlayEmojiRoute,PlayLeaderboardRoute: PlayLeaderboardRoute,PlayLinkUpRoute: PlayLinkUpRoute,PlayPosterRevealRoute: PlayPosterRevealRoute,PlayQuoteMatchRoute: PlayQuoteMatchRoute,PlayScreeningRoute: PlayScreeningRoute,PlaySequelOrFakeRoute: PlaySequelOrFakeRoute,PlaySpeedSortRoute: PlaySpeedSortRoute,PlayTaglinesRoute: PlayTaglinesRoute,PlayTimelineRoute: PlayTimelineRoute,TvIdRoute: TvIdRoute,NightIndexRoute: NightIndexRoute,PlayIndexRoute: PlayIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)